import React from "react";
import CancellationTermsModal from "./CancellationTermsModal";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalSection,
    StandardModalText
} from "src/components";

function CancellationModal(props) {
    const { showDialog, handleClose, confirmCallback, companyDetails } = props;    
    const subscriptionEnd = new Date(companyDetails.subscriptionEnd);

    const formattedSubscriptionEnd = subscriptionEnd instanceof Date ?
        new Intl.DateTimeFormat("default", { dateStyle: "full" }).format(subscriptionEnd)
        : subscriptionEnd;
    
    return (
        <StandardModal
            open={showDialog}
            onClose={handleClose}
            title="Cancel Subscription"
            widthMode="large"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <StandardModalActionButton onClick={handleClose}>
                        Close
                    </StandardModalActionButton>

                    <StandardModalActionButton
                        $variant="danger"
                        onClick={() => confirmCallback()}
                    >
                        Confirm
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection gap="0.75rem">
                <StandardModalText weight="700" size="1.25rem" color="#171A22">
                    {companyDetails.companyName}, are you sure you want to end your subscription?
                </StandardModalText>
                <StandardModalText>
                    Please click the <strong>Confirm</strong> button below to initiate the cancellation process for your subscription in your Me Business Account.
                </StandardModalText>

                <StandardModalText weight="700" color="#171A22">Here are some important details to note:</StandardModalText>
                <StandardModalText>The cancellation will take effect at the conclusion of your current billing period, precisely on <strong>{formattedSubscriptionEnd}</strong>.</StandardModalText>
                <StandardModalText>
                    After cancellation, your subscription will not automatically renew. However, you can restart your subscription at any time, and your account details will remain accessible to you.
                </StandardModalText>

                <CancellationTermsModal />
            </StandardModalSection>
        </StandardModal>
    );
}

export default CancellationModal;
